export default __webpack_public_path__ + "static/media/MaskGroup208.277d8e21.png";